import { defaultLang } from "../config/languages";

export const services = {
  postSessionToken: (body) => ({
    route: "api_gateway/frontend_borrower/financial/borrower/session/",
    method: "post",
    type: "login",
    body,
  }),
  getLoan: (loanId) => ({
    route: `financial/loan/${loanId}/`,
    method: "get",
  }),
  getAgentById: (agentId) => ({
    route: `financial/agent/${agentId}/`,
    method: "get",
  }),
  getMerchantById: (merchantId) => ({
    route: `financial/merchant/${merchantId}/`,
    method: "get",
  }),
  getOptInByLoanIdAndBorrowerId: (data) => ({
    route: `compliance/optin/borrower/${data?.loanId}/${data?.borrowerId}/`,
    method: "get",
    headers: {
      "Accept-Language": data?.language ? data.language : defaultLang,
    },
  }),
  processPatchCheckOptinConditions: (data) => ({
    route: `compliance/optin/borrower/`,
    method: "patch",
    body: data,
  }),
  processPatchLenderSpecificOptinConditions: (data) => ({
    route: `compliance/optin/borrower/`,
    method: "patch",
    body: {
      op: "processPatchLenderSpecificOptInConditions",
      id: data.optInsId,
    },
  }),
  processPatchSyncLenderOptIns: (data) => ({
    route: `compliance/optin/borrower/`,
    method: "patch",
    body: data,
  }),
  postCreateBorrowerOptin: (data) => ({
    route: "compliance/optin/borrower/",
    method: "post",
    body: data,
  }),
  postCreateBorrower: (data) => ({
    route: "financial/borrower/",
    method: "post",
    body: data,
  }),
  patchSetBorrowerIdToLoan: (data) => ({
    route: "financial/loan/",
    method: "patch",
    body: data,
  }),
  processPatchUpdateSignatureStatusForLoanLenderBorrowerContract: (id) => ({
    route: "financial/loan_application/",
    method: "patch",
    body: {
      op: "processPatchUpdateSignatureStatusForLoanLenderBorrowerContract",
      id: id,
    },
  }),
  getDeclaredIncomeById: (data) => ({
    route: `risk/income/${data?.loanId}/${data?.onboardingDetailsId}/`,
    method: "get",
  }),
  postDeclaredIncome: (data) => ({
    route: "risk/declared_income/",
    method: "post",
    body: data,
  }),
  patchAddBorrowerCashInCashOutMethod: (data) => ({
    route: "financial/borrower/",
    method: "patch",
    body: data,
  }),
  patchSetBorrowerCashInCashOutMethodToLoan: (data) => ({
    name: "loanApplication:patchSetBorrowerCashInCashOutMethodToLoan",
    route: "financial/loan/",
    method: "patch",
    body: data,
  }),
  getDocumentationRequired: (data) => ({
    route: `documentation/borrower/required/${data?.borrowerId}/loan/${data?.loanId}/single/`,
    method: "get",
  }),
  getSignatureUrlByLoanId: (loanId) => ({
    route: `financial/loan_application/signature/${loanId}/`,
    method: "get",
  }),
  getSignatureParamsByLoanId: (loanId) => ({
    route: `financial/loan_application/signature/${loanId}/?with_urls=0`,
    method: "get",
  }),
  getBorrowerFileByLoanIdBorrowerIdAndFileType: (data) => ({
    route: `documentation/borrower/file/${data.loanId}/${data.borrowerId}/${data.fileType}/`,
    method: "get",
  }),
  uploadBorrowerDocumentation: (data) => ({
    route: "documentation/borrower/required/",
    method: "patch",
    body: data,
  }),
  patchSetDocumentsConfirmed: (data) => ({
    route: "documentation/borrower/required/",
    method: "patch",
    body: data,
  }),
  patchSetUserDetailsWithKycProviderData: (data) => ({
    route: "api_gateway/frontend_borrower/financial/borrower/",
    method: "patch",
    body: data,
  }),
  patchSubmitKycVerification: (data) => ({
    route: "api_gateway/frontend_borrower/financial/borrower/",
    method: "patch",
    body: data,
  }),
  patchSetUserDetailsWithDeclaredData: (data) => ({
    route: "api_gateway/frontend_borrower/financial/borrower/",
    method: "patch",
    body: data,
  }),
  patchAssetDetailsWithLoanId: (data) => ({
    route: "financial/loan/",
    method: "patch",
    body: data,
  }),
  postDocumentIdImagesAction: (data) => ({
    route:
      "api_gateway/frontend_borrower/financial/borrower/document_id/images/",
    method: "post",
    body: data,
  }),
  getIdDocumentVerificationStatus: (data) => ({
    route: `compliance/id-document-verification/?onboarding_details_id=${data?.onboarding_details_id}`,
    method: "get",
  }),
  postIdDocumentVerificationStart: (data) => ({
    route: "compliance/id-document-verification/",
    method: "post",
    body: data,
  }),
  putIdDocumentVerificationFront: (data) => ({
    route: "compliance/id-document-verification/front/",
    method: "put",
    body: data,
  }),
  putIdDocumentVerificationBack: (data) => ({
    route: "compliance/id-document-verification/back/",
    method: "put",
    body: data,
  }),
  postIdDocumentVerificationVerify: (data) => ({
    route: "compliance/id-document-verification/verify/",
    method: "post",
    body: data,
  }),
  getIdDocumentVerificationExtractedData: (onboardingDetailsId) => ({
    route: `api_gateway/frontend_borrower/financial/borrower/id-document-verification/${onboardingDetailsId}/extracted-data/`,
    method: "get",
  }),
  processPatchSetUserDetailsWithIdDocumentVerificationFormData: (data) => ({
    route: "api_gateway/frontend_borrower/financial/borrower/",
    method: "patch",
    body: data,
  }),
  patchSetProfessionalDetails: (data) => ({
    route: "financial/borrower/",
    method: "patch",
    body: data,
  }),
  getBigQueryLoansByMerchantId: (payload) => ({
    route: `api_gateway/loan/loan_big_query/`,
    method: "get",
  }),
  getUserProfile: () => ({
    route: "security_and_acl/user/acl/profile/",
    method: "get",
  }),
  changeUserPassword: (body) => ({
    route: "security_and_acl/user/",
    method: "patch",
    body,
  }),
  getMerchantStructure: () => ({
    route: `financial/merchant/structure/`,
    method: "get",
  }),
  getPricingByLoanId: (loanId) => ({
    route: `financial/pricing/loan/${loanId}/`,
    method: "get",
  }),
  getAvailableLoanCalculators: (loanId) => ({
    route: `financial/loan/${loanId}/calculator/`,
    method: "get",
  }),
  getLoanAvailableCalculatorsByPrincipalAmount: (data) => ({
    route: `financial/loan/${data?.loanId}/calculator/?principal=${
      data?.principal
    }${data?.pricingIds ? `&pricing_ids=${data?.pricingIds}` : ""}`,
    method: "get",
  }),
  patchSetLoanCalculator: (data) => ({
    route: "financial/loan/",
    method: "patch",
    body: data,
  }),
  getLenderIdsByMerchantId: (merchantId) => ({
    route: `financial/lender/merchant/${merchantId}/`,
    method: "get",
  }),
  postLoanApplications: (data) => ({
    route: `financial/loan_application/`,
    method: "post",
    body: data,
  }),
  postCreateLoan: (loanData) => ({
    route: `financial/loan/`,
    method: "post",
    body: loanData,
  }),
  patchCancelLoan: (loanData) => ({
    route: `financial/loan/`,
    method: "patch",
    body: {
      op: "processPatchCancelLoan",
      ...loanData,
    },
  }),
  getMerchantProgramConditions: (merchantId) => ({
    route: `financial/merchant/program_conditions/${merchantId}/`,
    method: "get",
  }),
  patchAddLoanStep: (body) => ({
    route: "financial/loan/--", // TODO remove fake
    method: "patch",
    body,
  }),
  setLoanAssetStepMerchantIsCompletedService: (body) => ({
    route: "financial/loan/",
    method: "patch",
    body,
  }),
  getKycAuth: () => ({
    route:
      "api_gateway/frontend_borrower/financial/borrower/electronicid/auth/",
    method: "get",
  }),
  getProcessIdsEurobits: (loanId) => ({
    route: `api_gateway/eurobits/risk/bank_reader/borrower_bank_reader/bank_reader/${loanId}/process_id/`,
    method: "get",
  }),
  getBankReaderWidgetUrlEurobits: (data) => ({
    route: `api_gateway/eurobits/risk/bank_reader/borrower_bank_reader/widget-url/?processId=${data?.processId}&userId=${data?.documentIdNumber}&borrowerBankReaderId=${data?.borrowerBankReaderId}&borrowerId=${data?.borrowerId}&loanId=${data?.loanId}`,
    method: "get",
  }),
  postAddCashInCashOutMethodEurobits: (data) => ({
    route: `api_gateway/eurobits/risk/bank_reader/borrower_bank_reader/add_borrower_cash_in_cash_out_method/`,
    method: "post",
    body: data,
  }),
  getBankReaderWidgetUrlTink: (data) => ({
    route: `api_gateway/tink/risk/bank_reader/borrower_bank_reader/widget-url/?userId=${data?.documentIdNumber}&borrowerBankReaderId=${data?.borrowerBankReaderId}&borrowerId=${data?.borrowerId}&loanId=${data?.loanId}&redirectUrl=${data?.redirectUrl}`,
    method: "get",
  }),
  postCallbackBorrowerBankReaderTink: (data) => ({
    route: `api_gateway/tink/risk/bank_reader/borrower_bank_reader/`,
    method: "post",
    body: data,
  }),
  postAddCashInCashOutMethodTink: (data) => ({
    route: `api_gateway/tink/risk/bank_reader/borrower_bank_reader/add_borrower_cash_in_cash_out_method/`,
    method: "post",
    body: data,
  }),
  getBorrowerBankReaderById: (borrowerBankReaderId) => ({
    route: `risk/bank_reader/borrower_bank_reader/${borrowerBankReaderId}/`,
    method: "get",
  }),
  patchSyncBorrowerDocumentationByLoanId: (body) => ({
    route: `financial/loan/`,
    method: "patch",
    body,
  }),
  getCaixabankKyc: (data) => ({
    route: `caixabank/kyc/${data?.documentNumber}/loan/${data?.loanId}/`,
    method: "get",
  }),
  getCaixabankKycProjection: (loanId) => ({
    route: `financial/loan/${loanId}/is_known_customer/`,
    method: "get",
  }),
  getAssetDetails: (data) => ({
    route: `financial/asset/${data?.assetId}/${data?.assetType}/`,
    method: "get",
  }),
  patchSetBorrowerOnboardingDetailsByOnboardingDetailsId: (data) => ({
    route: "financial/loan/",
    method: "patch",
    body: data,
  }),
  getPaymentTokenByPaymentLineId: (paymentLineId) => ({
    route: `payment/payment-plan/line/${paymentLineId}/token/`,
    method: "get",
  }),
  getPaymentPlanByPaymentLineId: (paymentLineId) => ({
    route: `payment/payment-plan/line/${paymentLineId}/`,
    method: "get",
  }),
  patchUpdatePaymentPlanLineStatus: ({
    paymentPlanLineId,
    paymentPlanLineStatus,
  }) => ({
    route: `payment/payment-plan/`,
    method: "patch",
    body: {
      op: "processPatchUpdatePaymentPlanLineStatus",
      id: paymentPlanLineId,
      status: paymentPlanLineStatus,
    },
  }),
  postSetDigitalFootprint: (body) => ({
    route: `financial/onboarding/digital-footprint/`,
    method: "post",
    body,
  }),
  patchUpdateLoanConditionsByInsurance: (data) => ({
    route: `financial/loan/`,
    method: "patch",
    body: {
      op: "processPatchUpdateLoanConditionsByInsurance",
      ...data,
    },
  }),
  patchSetBorrowerIdToBorrowerOnboardingDetailsByEmailAndPhone: (data) => ({
    route: `financial/loan/`,
    method: "patch",
    body: {
      op: "processPatchSetBorrowerIdToBorrowerOnboardingDetailsByEmailAndPhone",
      ...data,
    },
  }),
  getCheckoutSessionByPaymentMethodId: (data) => ({
    route: `financial/checkout-session/payment-method/${data?.paymentMethodId}/`,
    method: "get",
  }),
  postManualChoose: (data) => ({
    route: `financial/loan_application/${data?.loanApplicationId}/loan/${data?.loanId}/manual_choose/`,
    method: "post",
  }),
  getLoanApplicationsByLoanId: (data) => ({
    route: `financial/loan_application/loan/${data?.loanId}/`,
    method: "get",
  }),
  postRequestBorrowerCall: (body) => ({
    route: `sync_and_integration/ticketing/request_borrower_call/`,
    method: "post",
    body,
  }),
};
